import { useStyles } from './styles';
import AppNumberInput from 'components/FormElements/AppNumberInput';
import { round } from 'lodash';

type Props = any; //TODO: define types

const TotalSaleValueCell: React.FC<Props> = ({
  cell,
  setOverride,
  disableTable,
}) => {
  const { classes } = useStyles();

  // Use suggested shares (what the backend recommended) to calculate the default value
  // This correctly handles cases where penny rounding adjustments have been applied
  const suggestedShares =
    Number(cell.suggestedSharesAllocatedForSale) ||
    Number(cell.sharesAllocatedForSale) ||
    0;
  // Round to 2 decimals to match totalSaleValue precision from backend
  const defaultValue = round(suggestedShares * Number(cell.sharePrice), 2);

  // Ensure totalSaleValue is never NaN
  const totalSaleValue = Number(cell.totalSaleValue) || 0;

  // Allow for ±0.01 penny rounding adjustments made by the backend
  // If difference is within this range, it's not a user edit
  const diff = Math.abs(round(totalSaleValue - defaultValue, 2));
  const isInputChanged = diff > 0.01;
  const className = isInputChanged ? classes.inputChanged : '';

  return (
    <AppNumberInput
      key={`total-sale-${cell.shareholdingId}`}
      disabled={disableTable}
      decimals={2}
      placeholder="0"
      defaultValue={0}
      min={0}
      currencyStartAdornment
      value={totalSaleValue}
      onChange={(newValue) => {
        setOverride(cell.shareholdingId, {
          totalSaleValue: Number(newValue) || 0,
        });
      }}
      className={className}
    />
  );
};

export default TotalSaleValueCell;
